import React from "react";
import { Sparkle } from "lucide-react";

const STOREFRONT_IMG = "https://static.prod-images.emergentagent.com/jobs/58b9db56-cadc-45a5-adbe-d1405ee34b6f/images/68833f5dec69685d3a1fb74da54ca4e8d7120d0580b8cde57c6ab46ca0fd00ab.png";

export function Logo({ light = false, size = "text-3xl", iconClass = "w-9 h-9", showIcon = true }) {
  return (
    <span className="flex items-center gap-2">
      {showIcon && <img src={STOREFRONT_IMG} alt="Voyes" className={`${iconClass} object-contain`} />}
      <span className={`relative inline-block font-logo font-semibold leading-none select-none ${light ? "text-white" : "text-slate-900"} ${size}`}>
        voyes
        <Sparkle
          className="absolute w-3.5 h-3.5 text-orange-500 fill-orange-500"
          style={{ top: "-0.35em", right: "-0.45em" }}
          strokeWidth={1.5}
        />
      </span>
    </span>
  );
}
